import useDynamicPages from "@/hooks/useDynamicPages";

export const useDynamicPage = (url_slug) => useDynamicPages().find((i) => i.url_slug === url_slug);

export default useDynamicPage;
